module.exports = __webpack_public_path__ + "static/media/icon-play-button-green.25dd3616.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-play-button-green.svg
// module id = 173
// module chunks = 0